import React from 'react';
import { DropdownSearchContainer, DropdownSearchInput } from './DropdownSearch.styles';
import { SearchIcon } from './icons';

export const DropdownSearch = ({ 
    placeholder = "Search...", 
    value, 
    onChange, 
    showBorder = true 
}) => {
    return (
        <DropdownSearchContainer showBorder={showBorder}>
            <SearchIcon />
            <DropdownSearchInput
                placeholder={placeholder}
                value={value}
                onChange={onChange}
            />
        </DropdownSearchContainer>
    );
};